import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';
// Import social icons from your assets folder
import facebookIcon from '../assets/fb.png';
import instagramIcon from '../assets/insta.png';
import youtubeIcon from '../assets/you.png';
import twitterIcon from '../assets/twit.png';
// Import logo from assets
import logo from '../assets/logo.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', url: '/' },
    { name: 'Rooms', url: '/rooms' },
    { name: 'Gallery', url: '/gallery' },
    { name: 'About', url: '/about' },
    { name: 'Contact', url: '/contact' }
  ];

  const socialLinks = [
    { name: 'Facebook', icon: facebookIcon, url: 'https://facebook.com' },
    { name: 'Instagram', icon: instagramIcon, url: 'https://instagram.com' },
    { name: 'YouTube', icon: youtubeIcon, url: 'https://youtube.com' },
    { name: 'Twitter', icon: twitterIcon, url: 'https://twitter.com' }
  ];

  const contactInfo = [
    { icon: '📍', text: 'Ameerpet Metro Pillar No. 1072, Above Bata Showroom, First Floor, Hyderabad, Telangana' },
    { icon: '📞', text: '+91 8019472678' },
    { icon: '📧', text: 'info@hotelsinhyderabad.com' },
    { icon: '🕐', text: '24/7 Open' }
  ];

  return (
    <footer className="ftr-footer">
      <div className="ftr-container">
        {/* Main Footer Content */}
        <div className="ftr-grid">
          {/* Brand Column */}
          <div className="ftr-brand">
            <div className="ftr-logo">
              <img 
                src={logo} 
                alt="AA GRAND HOTEL" 
                className="ftr-logo-img"
              />
            </div>
            <p className="ftr-brand-description">
              Where luxury meets hospitality in the heart of Hyderabad. 
              Experience world-class comfort, warm hospitality, and unforgettable stays.
            </p>
            <div className="ftr-social">
              {socialLinks.map((social) => (
                <a 
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ftr-social-link"
                  aria-label={social.name}
                >
                  <img 
                    src={social.icon} 
                    alt={social.name}
                    className="ftr-social-icon"
                  />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="ftr-links">
            <h4 className="ftr-heading">Quick Links</h4>
            <ul className="ftr-link-list">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link to={link.url} className="ftr-link">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="ftr-contact">
            <h4 className="ftr-heading">Contact Us</h4>
            <ul className="ftr-contact-list">
              {contactInfo.map((item, index) => (
                <li key={index} className="ftr-contact-item">
                  <span className="ftr-contact-icon">{item.icon}</span>
                  <span className="ftr-contact-text">{item.text}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter / Short Stay */}
          <div className="ftr-newsletter">
            <h4 className="ftr-heading">Quick Stay</h4>
            <p className="ftr-newsletter-text">
              Book your 4-hour short stay package at special rates. Perfect for quick getaways!
            </p>
            <a href="tel:+918019472678" className="ftr-newsletter-btn">
              📞 Call Now
            </a>
            <div className="ftr-badge">
              <span>⭐</span>
              <div>
                <strong>4.8/5</strong>
                <p>Guest Rating</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="ftr-bottom">
          <div className="ftr-bottom-content">
            <p className="ftr-copyright">
              &copy; {currentYear} HotelsInHyderabad (AA GRAND HOTEL). All Rights Reserved.
            </p>
            <div className="ftr-bottom-links">
              <Link to="/privacy-policy" className="ftr-bottom-link">Privacy Policy</Link>
              <span className="ftr-bottom-divider">|</span>
              <Link to="/terms" className="ftr-bottom-link">Terms &amp; Conditions</Link>
              <span className="ftr-bottom-divider">|</span>
              <Link to="/" className="ftr-bottom-link">Sitemap</Link>
            </div>
          </div>
          <div className="ftr-bottom-credit">
            <p>Designed by Tririse Digital</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;